var bookingOptions = ["location", "service", "people", "dates", "details"];
var bookingOptionsPosition = 0;
var availableTimeSlots = {};
var availableDates = [];
var peoplesServices = [];

var selectedLocationId = 0;
var selectedServiceId = 0;
var selectedProviderId = 0;
var selectedBookingDate = "";
var selectedBookingTime = "";
var selectedEndPoint = "";

var processingBooking = false;

var cachedClubroomAPIBookingData = JSON.parse(
  localStorage.getItem("cachedClubroomAPIBookingData")
);
var cachedClubroomAPIBookingTime = localStorage.getItem(
  "cachedClubroomAPIBookingTime"
);

const today = new Date();
const formattedDateToday = `${today.getFullYear()}-${String(
  today.getMonth() + 1
).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
const oneMonthFromNow = new Date();
oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
const formattedDateOneMonthFromNow = `${oneMonthFromNow.getFullYear()}-${String(
  oneMonthFromNow.getMonth() + 1
).padStart(2, "0")}-${String(oneMonthFromNow.getDate()).padStart(2, "0")}`;

var options = {
  type: "default",
  settings: {
    visibility: {
      theme: "light",
      weekend: false,
      today: false,
    },
    range: {
      min: formattedDateToday,
      max: formattedDateOneMonthFromNow,
    },
  },
  actions: {
    clickDay(e, date) {
      updateDatesAvailableTimes(date);
    },
  },
};

var calendar = new VanillaCalendar("#calendar", options);

function getBookingInfo() {
  if (
    cachedClubroomAPIBookingData &&
    cachedClubroomAPIBookingTime &&
    Date.now() - cachedClubroomAPIBookingTime < 900000
  ) {
    simplybookForm();
    document.getElementById("splash-screen").style.display = "none";
  } else {
    fetch("https://theclubroom-api.azurewebsites.net/booking/info")
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem(
          "cachedClubroomAPIBookingData",
          JSON.stringify(data)
        );
        localStorage.setItem("cachedClubroomAPIBookingTime", Date.now());
        cachedClubroomAPIBookingData = data;
        simplybookForm();
        document.getElementById("splash-screen").style.display = "none";
      })
      .catch((error) => {
        console.error("Error fetching locations:", error);
        throw error; // Re-throw the error
      });
  }
}
function handleLocationChange(locationRadio) {
  selectedLocationId = 0;
  selectedServiceId = 0;
  uncheckAllServiceRadios();
  selectedProviderId = 0;
  uncheckAllPeopleRadios();
  selectedBookingDate = "";
  selectedBookingTime = "";
  let providers = locationRadio.getAttribute("providers").split(",");
  let services = document.querySelectorAll(".services-radio");
  if (locationRadio.checked) {
    selectedLocationId = locationRadio.getAttribute("location_id");
    selectedLocationRadioId = locationRadio.getAttribute("id");
    selectedEndPoint = locationRadio.getAttribute("location_endpoint");
    switch (selectedLocationRadioId) {
      case "location-radio-2-theclubroomnz":
        moveMapToLocation("auckland");
        break;
      case "location-radio-1-theclubroomnztauranga":
        moveMapToLocation("tauranga");
        break;
      default: //Albany by default
        moveMapToLocation("albany");
        break;
    }
    let locationNameElements = document.getElementsByClassName(
      "booking-location-name"
    );
    for (let element of locationNameElements) {
      element.innerHTML = locationRadio.value;
    }
    let locationAddressElements = document.getElementsByClassName(
      "booking-location-address"
    );
    for (let element of locationAddressElements) {
      element.innerHTML = locationRadio.getAttribute("locationdetails");
    }
    populateServicesContainer();
  }
}

function handleServiceChange(serviceRadio) {
  selectedProviderId = 0;
  uncheckAllPeopleRadios();
  selectedBookingDate = "";
  selectedBookingTime = "";
  let serviceId = serviceRadio.getAttribute("service_id");
  let locationId = serviceRadio.getAttribute("service_id");
  let people = document.querySelectorAll(".people-radio");
  if (serviceRadio.checked) {
    selectedServiceId = serviceRadio.getAttribute("service_id");
    let serviceNameElements = document.getElementsByClassName(
      "booking-service-name"
    );
    for (let element of serviceNameElements) {
      element.innerHTML = serviceRadio.value;
    }

    let serviceDetailsElements = document.getElementsByClassName(
      "booking-service-details"
    );
    for (let element of serviceDetailsElements) {
      element.innerHTML = serviceRadio.getAttribute("servicedetails");
    }
    populatePeopleContainer(selectedServiceId, locationId);
  }
}

function getLocationEndpointVariable() {
  let urlObj = new URL(window.location.href);
  let params = new URLSearchParams(urlObj.search);
  if (!params.get("location_endpoint")) return "";
  return params.get("location_endpoint");
}

function getLocationIdVariable() {
  let urlObj = new URL(window.location.href);
  let params = new URLSearchParams(urlObj.search);
  if (!params.get("location_id")) return "";
  return params.get("location_id");
}

function getProviderVariable() {
  let urlObj = new URL(window.location.href);
  let params = new URLSearchParams(urlObj.search);
  if (!params.get("provider")) return "";
  return params.get("provider");
}

function getServiceVariable() {
  let urlObj = new URL(window.location.href);
  let params = new URLSearchParams(urlObj.search);
  if (!params.get("service")) return "";
  return params.get("service");
}

function handlePersonChange(personRadio) {
  if (personRadio.checked) {
    selectedProviderId = personRadio.getAttribute("people_id");
    selectedProviderId = personRadio.getAttribute("people_id");
    selectedProviderId = personRadio.getAttribute("people_id");
    let personNameElements = document.getElementsByClassName(
      "booking-person-name"
    );
    for (let element of personNameElements) {
      element.innerHTML = personRadio.value;
    }
    getAvailableTimeSlots();
  }
}

function getAvailableTimeSlots() {
  const params = new URLSearchParams({
    serviceId: selectedServiceId,
    providerId: selectedProviderId,
    company: selectedEndPoint,
    startDate: formattedDateToday,
  });

  fetch(`https://theclubroom-api.azurewebsites.net/booking/available-times?${params}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      availableTimeSlots = data;
      calendar.settings.range.disabled = [];
      for (let d = new Date(formattedDateToday); d <= new Date(formattedDateOneMonthFromNow); d.setDate(d.getDate() + 1)) {
        const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        if (!availableTimeSlots[dateStr]?.length) {
          calendar.settings.range.disabled.push(dateStr);
        }
      }
      if (availableTimeSlots[formattedDateToday]) {
        updateDatesAvailableTimes(formattedDateToday);
      }
      calendar.reset();
    })
    .catch((error) => {
      console.error("Error fetching available time slots:", error);
      throw error;
    });
}


function simplybookForm() {
  populateLocationsContainer();

  const bookingForms = document.querySelectorAll("[data-booking-form]");
  if (bookingForms) {
    bookingForms.forEach((bookingForm) => {
      const steps = bookingForm.querySelectorAll("[data-booking-step]");
      if (steps) {
        steps.forEach((step) => {
          const backButton = step.querySelector("[data-button-prev]");
          if (backButton) {
            if (step.previousElementSibling) {
              backButton.classList.remove("opacity-40");
              backButton.addEventListener("click", (e) => {
                if (bookingOptionsPosition > 0) {
                  bookingOptionsPosition--;
                  smoothScrollTo(bookingForm.parentNode);
                }
                steps.forEach((stepDiv) => {
                  stepDiv.classList.remove("flex");
                  stepDiv.classList.add("hidden");
                });
                if (step.previousElementSibling) {
                  step.previousElementSibling.classList.remove("hidden");
                  step.previousElementSibling.classList.add("flex");
                }
              });
            } else {
              backButton.classList.add("opacity-40");
            }
          }
          const nextButton = step.querySelector("[data-button-next]");
          if (nextButton) {
            if (step.nextElementSibling) {
              nextButton.addEventListener("click", (e) => {
                if (
                  bookingOptionsPosition == 0 &&
                  !isAnyLocationRadioSelected()
                ) {
                  alert("Please select a location");
                  return;
                }
                if (
                  bookingOptionsPosition == 1 &&
                  !isAnyServiceRadioSelected()
                ) {
                  alert("Please select a Service");
                  return;
                }
                if (
                  bookingOptionsPosition == 2 &&
                  !isAnyPersonRadioSelected()
                ) {
                  alert("Please select a Staff Member");
                  return;
                }
                if (
                  bookingOptionsPosition == 3 &&
                  !isBookingADateTimeSelected()
                ) {
                  alert("Please select a date and time");
                  return;
                }
                bookingOptionsPosition++;
                smoothScrollTo(bookingForm.parentNode);
                steps.forEach((stepDiv) => {
                  stepDiv.classList.remove("flex");
                  stepDiv.classList.add("hidden");
                });

                step.nextElementSibling.classList.remove("hidden");
                step.nextElementSibling.classList.add("flex");
              });
            }
          }
        });
      }
    });
  }

  calendar.init();
  preSelectBookingOptions();
}

function preSelectBookingOptions() {
  try {
    if (getLocationIdVariable() != "" && getLocationEndpointVariable() != "") {
      document
        .getElementById(
          "location-radio-" +
            getLocationIdVariable() +
            "-" +
            getLocationEndpointVariable()
        )
        .click();
      document.querySelectorAll("[data-button-next]")[0].click();
      if (getServiceVariable() != "") {
        document
          .getElementById("services-radio-" + getServiceVariable())
          .click();
        document.querySelectorAll("[data-button-next]")[1].click();
        if (getProviderVariable() != "") {
          document
            .getElementById("people-radio-" + getProviderVariable())
            .click();
          document.querySelectorAll("[data-button-next]")[2].click();
        }
      }
    }
  } catch (error) {}
}

function isAnyLocationRadioSelected() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="location-radio"]'
  );

  for (let radio of radios) {
    if (radio.checked) {
      return true; // At least one radio input is checked
    }
  }
  return false; // No radio inputs are checked
}

function isAnyServiceRadioSelected() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="services-radio"]'
  );

  for (let radio of radios) {
    if (radio.checked) {
      return true; // At least one radio input is checked
    }
  }
  return false; // No radio inputs are checked
}

function uncheckAllServiceRadios() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="services-radio"]'
  );
  for (let radio of radios) {
    radio.checked = false;
  }
  let serviceNameElements = document.getElementsByClassName(
    "booking-service-name"
  );
  for (let element of serviceNameElements) {
    element.innerHTML = "";
  }
  let serviceDetailsElements = document.getElementsByClassName(
    "booking-service-details"
  );
  for (let element of serviceDetailsElements) {
    element.innerHTML = "";
  }
}

function isAnyPersonRadioSelected() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="people-radio"]'
  );

  for (let radio of radios) {
    if (radio.checked) {
      return true; // At least one radio input is checked
    }
  }
  return false; // No radio inputs are checked
}

function uncheckAllPeopleRadios() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="people-radio"]'
  );

  for (let radio of radios) {
    radio.checked = false;
  }
  let personNameElements = document.getElementsByClassName(
    "booking-person-name"
  );
  for (let element of personNameElements) {
    element.innerHTML = "";
  }
}

function isBookingADateTimeSelected() {
  return selectedBookingDate != "" && selectedBookingTime != "";
}

function populateLocationsContainer() {
  cachedClubroomAPIBookingData.forEach((location, index) => {
    document.getElementById("booking-location-holder").innerHTML += `
            <div class="flex gap-6">
              <input onchange="handleLocationChange(this)" location_id="${location.id}" location_endpoint="${location.location_endpoint}" providers="${location.providers}" id="location-radio-${location.id}-${location.location_endpoint}" type="radio" value="${location.name}" locationdetails="${location.full_address}" name="location-radio" class="w-8 h-8 bg-gray-100 border-2 border-gray-300 location-radio text-dark-blue focus:ring-dark-blue dark:focus:ring-dark-blue focus:ring-2">
              <div class="flex flex-col">
                  <label for="location-radio-${location.id}-${location.location_endpoint}" class="pt-1 uppercase font-black leading-none text-dark-blue text-base md:text-[20px] max-w-md">${location.name}</label>
                  <p class="uppercase text-[14px] font-bold leading-tight text-text mt-2">
                      ${location.full_address}
                  </p>
              </div>
            </div>
        `;
  });
}

function populateServicesContainer() {
  var selectedLocation;
  cachedClubroomAPIBookingData.forEach((location, index) => {
    if (
      location.id == selectedLocationId &&
      location.location_endpoint == selectedEndPoint
    )
      selectedLocation = location;
  });
  document.getElementById("booking-services-holder").innerHTML = "";
  selectedLocation.services.forEach((service, index) => {
    if (!service.is_visible || service.name.startsWith("Simulator")) return;
    if (service.description == null) service.description = "";
    document.getElementById("booking-services-holder").innerHTML += `
            <div class="flex gap-6">
              <input onchange="handleServiceChange(this)" service_id="${service.id}" id="services-radio-${service.id}" type="radio" value="${service.name}" servicedetails="${service.duration} minutes · $${service.price}" name="services-radio" class="w-8 h-8 bg-gray-100 border-2 border-gray-300 services-radio text-dark-blue focus:ring-dark-blue dark:focus:ring-dark-blue focus:ring-2">
              <div class="flex flex-col">
                <label for="services-radio-${service.id}" class="pt-1 uppercase font-black leading-none text-dark-blue text-base md:text-[20px] max-w-md">${service.name}</label>
                <p class="uppercase text-[14px] font-bold leading-tight text-text mt-2">${service.duration} minutes · $${service.price}</p>
                <div class="prose text-[12px] font-medium leading-snug prose-p:my-1 mt-1 -ml-14 xl:ml-0">
                  ${service.description}
                </div>
              </div>
            </div>
        `;
  });
}

function populatePeopleContainer() {
  var selectedLocation;
  cachedClubroomAPIBookingData.forEach((location, index) => {
    if (
      location.id == selectedLocationId &&
      location.location_endpoint == selectedEndPoint
    )
      selectedLocation = location;
  });
  var selectedService;
  selectedLocation.services.forEach((service, index) => {
    if (service.id == selectedServiceId) selectedService = service;
  });
  const headCoachNames = document.getElementById("booking-people-holder")
    .dataset.headCoach;
  let headCoachNamesArray = [];
  if (headCoachNames) {
    headCoachNamesArray = headCoachNames.split(",").map((name) => name.trim());
  }
  document.getElementById("booking-people-holder").innerHTML = "";
  selectedService.full_providers.forEach((person, index) => {
    if (person.description == null) person.description = "";

    // Check if this person is a head coach
    const isHeadCoach = headCoachNamesArray.includes(person.name.trim());
    const headCoachClass = isHeadCoach ? " is-head-coach order-first" : "";

    document.getElementById("booking-people-holder").innerHTML += `
            <div class="flex gap-6 items-start p-4 rounded-md bg-gray group relative${headCoachClass}">
                <div class="hidden group-[.is-head-coach]:block absolute inset-0 w-full h-full bg-white border-2 border-primary rounded-md z-0"></div>
                <input
                  onchange="handlePersonChange(this)"
                  people_id="${person.id}"
                  id="people-radio-${person.id}"
                  type="radio"
                  value="${person.name}"
                  name="people-radio"
                  class="w-6 h-6 relative bg-gray-100 border-2 border-gray-300 md:w-8 md:h-8 people-radio text-dark-blue focus:ring-dark-blue dark:focus:ring-dark-blue focus:ring-2"
                >
                <div class="flex flex-col relative">
                  <div class="flex gap-6">
                    <div class="flex flex-col">
                      <div class="hidden group-[.is-head-coach]:block uppercase text-sm font-bold leading-tight">
                        Head Coach
                      </div>
                      <label
                        for="people-radio-${person.id}"
                        class="pt-1 uppercase font-black leading-none text-dark-blue text-base md:text-[20px]"
                        >${person.name}</label
                      >
                    </div>
                  </div>
                  <div class="prose text-[12px] font-medium leading-snug prose-p:my-1 mt-4 xl:mt-1 md:-ml-12 xl:ml-0">
                    ${person.description}
                  </div>
                </div>
                <div class="overflow-hidden relative w-full rounded max-w-24 ml-auto mr-0">
                    <div class="relative w-full h-0 pt-[120%]"></div>
                    <img
                    class="object-cover absolute inset-0 w-full h-full"
                    src="https://simplybook.me${person.picture_preview}"
                    alt=""
                    >
                </div>
              </div>
        `;
  });
}

function haveSharedValues(arr1, arr2) {
  const set1 = new Set(
    arr1.map((item) => (typeof item === "string" ? parseInt(item, 10) : item))
  );
  for (let value of arr2) {
    const intValue = typeof value === "string" ? parseInt(value, 10) : value;
    if (set1.has(intValue)) {
      return true;
    }
  }
  return false;
}

function updateDatesAvailableTimes(date) {
  document.getElementById("timeHolderContainer").classList.add("hidden");
  document.getElementById("timeHolder").innerHTML = "";
  selectedBookingDate = date;
  selectedBookingTime = "";
  const times = availableTimeSlots[date] || [];
  times.forEach((time, timeIndex) => {
    if (isTimeAm(time)) {
      addMorningTime(time, convertTo12HourFormat(time), timeIndex);
    } else {
      addAfternoonTime(time, convertTo12HourFormat(time), timeIndex);
    }
  });
}

function addMorningTime(timeValue, timeFormatted, timeIndex) {
  document.getElementById("timeHolderContainer").classList.remove("hidden");
  document.getElementById("timeHolder").innerHTML += `
        <li class="relative">
          <input
            type="radio"
            id="morning-time-${timeIndex}"
            name="time"
            onchange="setSelectedTime(this)"
            displaytime="${timeFormatted}"
            value="${timeValue}"
            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer peer"
            required
          >
          <label
            for="morning-time-${timeIndex}"
            class=" px-3 py-2 text-[11px] font-bold rounded bg-white peer-hover:bg-dark-blue peer-hover:text-white peer-checked:bg-dark-blue peer-checked:text-white ease-custom transition-all"
            >${timeFormatted}</label
          >
        </li>
        `;
}

function addAfternoonTime(timeValue, timeFormatted, timeIndex) {
  document.getElementById("timeHolderContainer").classList.remove("hidden");
  document.getElementById("timeHolder").innerHTML += `
        <li class="relative">
          <input
            type="radio"
            id="afternoon-time-${timeIndex}"
            name="time"
            onchange="setSelectedTime(this)"
            displaytime="${timeFormatted}"
            value="${timeValue}"
            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer peer"
            required
          >
          <label
            for="time-${timeIndex}"
            class=" px-3 py-2 text-[11px] font-bold rounded bg-white peer-hover:bg-dark-blue peer-hover:text-white peer-checked:bg-dark-blue peer-checked:text-white ease-custom transition-all"
            >${timeFormatted}</label
          >
        </li>
        `;
}

function setSelectedTime(timeRadio) {
  if (timeRadio.checked) {
    selectedBookingTime = timeRadio.value;
    let timeNameElements = document.getElementsByClassName("booking-date-name");
    for (let element of timeNameElements) {
      let dateObj = new Date(selectedBookingDate);
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      element.innerHTML = `${days[dateObj.getDay()]}, ${dateObj.getDate()} ${
        months[dateObj.getMonth()]
      } ${timeRadio.getAttribute("displaytime")}`;
    }
  }
}

document.forms["bookingformsubmit"].onsubmit = function (event) {
  if (processingBooking) return;
  processingBooking = true;
  event.preventDefault();

  const bookingFname = document.getElementById("bookinginfofname").value;
  const bookingLname = document.getElementById("bookinginfolname").value;
  const bookingEmail = document.getElementById("bookinginfoemail").value;
  const bookingPhone = document.getElementById("bookinginfophone").value;

  if (!bookingFname || !bookingLname || !bookingEmail || !validateEmail(bookingEmail) || !bookingPhone)
    return;

  document.querySelector("[data-button-submit]").innerHTML =
    "<span class='uppercase font-black text-base md:text-[20px]'>Submitting...</span>";

  return fetch("https://theclubroom-api.azurewebsites.net/booking/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      firstName: bookingFname,
      lastName: bookingLname,
      email: bookingEmail,
      phone: bookingPhone,
      bookingTime: `${selectedBookingDate}T${selectedBookingTime}`,
      serviceId: selectedServiceId,
      providerId: selectedProviderId,
      locationId: selectedLocationId,
      company: selectedEndPoint,
    }),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      document.querySelector("[data-button-submit]").innerHTML =
        "<span class='uppercase font-black text-base md:text-[20px]'>Success!</span>";
      document.querySelector("[data-button-submit]").classList.remove("bg-dark-blue");
      document.querySelector("[data-button-submit]").classList.add("bg-green-500");
    })
    .catch((error) => {
      processingBooking = false;
      document.querySelector("[data-button-submit]").innerHTML =
        "<span class='uppercase font-black text-base md:text-[20px]'>Error</span>";
      document.querySelector("[data-button-submit]").classList.remove("bg-dark-blue");
      document.querySelector("[data-button-submit]").classList.add("bg-red-500");
      throw error;
    });
};

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function isTimeAm(time) {
  const hour = parseInt(time.split(":")[0], 10);
  if (hour < 12) {
    return true;
  } else {
    return false;
  }
}

function convertTo12HourFormat(time) {
  let [hour, minute] = time.split(":").map((val) => parseInt(val, 10));

  let period = hour < 12 ? "AM" : "PM";

  // Convert to 12-hour format
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }
  if (minute == 0) return `${hour}${period}`;
  return `${hour}:${minute}${period}`;
}

window.addEventListener("load", (event) => {
  getBookingInfo();
});

var map;
var service;

var icon = {
  url: "https://cdn.shopify.com/s/files/1/0024/8725/5152/files/The_Clubroom_Logo_w_Tagline_-_Positive_CMYK_1.png?v=1678748489",
  scaledSize: new google.maps.Size(111, 64),
};

const locations = {
  auckland: {
    coords: { lat: -36.862846, lng: 174.7563726 },
    placeId: "ChIJ-0mMCsFHDW0R0Otj_8RU8P8",
  },
  albany: {
    coords: { lat: -36.745953, lng: 174.698648 },
    placeId: "ChIJScYOa_U7DW0RNPtVdTC5gGs",
  },
  hamilton: {
    coords: { lat: -37.748805, lng: 175.2325864 },
    placeId: "ChIJ5VPQungjbW0RyBEMS1oyosI",
  },
  tauranga: {
    coords: { lat: -37.730332, lng: 176.122273 },
    placeId: "ChIJg7iFwYrabW0RXZ78TRiTIn8",
  },
};

function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 14,
    center: locations.auckland.coords,
    mapId: "80c3947241fcc505",
    mapTypeControl: false,
  });

  service = new google.maps.places.PlacesService(map);

  service.getDetails(
    {
      placeId: locations.auckland.placeId,
    },
    function (result, status) {
      var marker = new google.maps.Marker({
        place: {
          placeId: locations.auckland.placeId,
          location: result.geometry.location,
        },
        map: map,
        icon: icon,
      });
    }
  );
}

function moveMapToLocation(location) {
  map.setCenter(locations[location].coords);
  service.getDetails(
    {
      placeId: locations[location].placeId,
    },
    function (result, status) {
      var marker = new google.maps.Marker({
        place: {
          placeId: locations[location].placeId,
          location: result.geometry.location,
        },
        map: map,
        icon: icon,
      });
    }
  );
}

initMap();

function smoothScrollTo(element) {
  const startPosition = window.pageYOffset;
  const targetPosition =
    element.getBoundingClientRect().top + window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 100; // Duration of the animation in milliseconds
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    window.scrollTo(0, startPosition + progress * distance);
    if (progress < 1) {
      window.requestAnimationFrame(animation);
    }
  }

  window.requestAnimationFrame(animation);
}
